import en from './en';
import tr from './tr';
import de from './de';
import fr from './fr';
import es from './es';
import ru from './ru';
import el from './el';

export const LEGAL = { en, tr, de, fr, es, ru, el };
